export const decreaseIndexUntil = limitingIndex => (currentIndex = 0) => {
  if (currentIndex > 0) return currentIndex - 1;
  return limitingIndex;
};

export const increaseIndexUntil = limitingIndex => (currentIndex = 0) => {
  if (currentIndex < limitingIndex - 1) return currentIndex + 1;
  return limitingIndex;
};
